// @flow

import { type PendingIncomingPayment } from './types';

export function getBindQRCodeImage(incomingPayment: PendingIncomingPayment): string {
  const ewallet = incomingPayment.ewallet;
  if (!ewallet || !ewallet.qr_code_image) {
    throw new Error('Bind QR code image is not available');
  }

  return ewallet.qr_code_image;
}

export function getBindQRCodeValue(incomingPayment: PendingIncomingPayment): string {
  const ewallet = incomingPayment.ewallet;
  if (!ewallet || !ewallet.qr_code_value) {
    throw new Error('Bind QR code value is not available');
  }

  return ewallet.qr_code_value;
}
